import { useState } from 'react';
import { Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { PartnerAccountsList } from '@/components/partner-accounts/PartnerAccountsList';
import { AddPartnerAccountDialog } from '@/components/partner-accounts/AddPartnerAccountDialog';
import { usePartnerAccountsWithPolling } from '@/api/partner-accounts';
import { useSyncStatusInvalidationForList } from '@/hooks/useSyncStatusInvalidation';

export function PartnerAccountsPage(): JSX.Element {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);

  // Uses polling only when accounts are actively syncing
  const { data: accounts, isLoading, error } = usePartnerAccountsWithPolling({
    includeCounts: true,
  });

  // Invalidate sync logs when any account's sync completes
  useSyncStatusInvalidationForList(accounts);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Partner Accounts</h1>
          <p className="text-muted-foreground">
            Connect and manage your property management platform accounts.
          </p>
        </div>
        <Button onClick={() => { setIsAddDialogOpen(true); }} data-testid="add-partner-account-btn">
          <Plus className="mr-2 h-4 w-4" />
          Add Partner Account
        </Button>
      </div>

      {error ? (
        <div className="rounded-lg border border-destructive bg-destructive/10 p-4">
          <p className="text-sm text-destructive">
            Failed to load partner accounts. Please try again.
          </p>
        </div>
      ) : (
        <PartnerAccountsList accounts={accounts ?? []} isLoading={isLoading} />
      )}

      <AddPartnerAccountDialog open={isAddDialogOpen} onOpenChange={setIsAddDialogOpen} />
    </div>
  );
}
